/** Maximum delivery round exposed in PE / redemption catalog selects. */
export const MAX_CATALOGO_ENTREGAS = 6;

/** Parses the trailing integer from catalog labels such as «Entrega 3». */
export function entregaNumeroFromNombre(nombre: string): number | null {
  const m = String(nombre ?? '').trim().match(/(\d+)\s*$/);
  if (!m) return null;
  const n = Number(m[1]);
  return Number.isFinite(n) ? n : null;
}

/** Keeps only active catalog rows numbered 1…{@link MAX_CATALOGO_ENTREGAS}. */
export function filterEntregasCatalogMax<T extends { nombre: string }>(rows: readonly T[]): T[] {
  return rows.filter((row) => {
    const n = entregaNumeroFromNombre(row.nombre);
    return n != null && n >= 1 && n <= MAX_CATALOGO_ENTREGAS;
  });
}
